import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TadarabLogo from "../icons/TadarabLogo";

export default function LandingPageNavbar({ isSuccessPage = false }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Handle transparent vs solid background
      if (currentScrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // Handle scroll direction (hide/show navbar)
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down (swiping up) - Hide nav
        setIsHidden(true);
      } else if (currentScrollY < lastScrollY - 10 || currentScrollY <= 10) {
        // Scrolling up (swiping down) by at least 10px OR at the top - Show nav
        setIsHidden(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* ===== NAVBAR ===== */}
      <nav
        className={`navbar landing-navbar px-0 ${isScrolled ? "scrolled" : ""} ${isHidden ? "nav-hidden" : ""}`}
      >
        <div className="landing-page__container w-100 d-flex align-items-center justify-content-between">
          {isSuccessPage ? (
            <>
              {/* Logo */}
              <div className="d-flex align-items-center">
                <Link className="d-flex flex-column align-items-center" to="/">
                  <TadarabLogo className="landing-page__brand-logo" />
                  <span className="landing-navbar__business-text text-end">
                    for business
                  </span>
                </Link>
              </div>

              {/* Back Button */}
              <div className="d-flex align-items-center">
                <Link
                  to="/"
                  className="d-flex align-items-center gap-2 text-white font-weight-bold"
                  style={{ textDecoration: "none", fontSize: "1rem" }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ transform: "scaleX(-1)" }}
                  >
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                  </svg>
                  <span>الرجوع</span>
                </Link>
              </div>
            </>
          ) : (
            <>
              {/* Mobile: hamburger */}
              <div className="d-flex d-lg-none align-items-center gap-3 landing-navbar__side justify-content-start">
                <button
                  className="navbar-toggler border-0 p-0 landing-navbar__toggler"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                >
                  <span className="landing-navbar__toggler-icon-line landing-navbar__toggler-icon-line--full" />
                  <span className="landing-navbar__toggler-icon-line landing-navbar__toggler-icon-line--full" />
                  <span className="landing-navbar__toggler-icon-line landing-navbar__toggler-icon-line--short" />
                </button>
              </div>

              {/* Logo - center on desktop, right on mobile */}
              <div className="d-flex flex-column align-items-center landing-navbar__logo-container mx-lg-auto">
                <Link to="/">
                  <img src="/images/logo-light.svg" alt="logo" />
                </Link>
              </div>

              {/* Left section (RTL layout: displays on the left) */}
              <div className="d-none d-lg-flex gap-3 align-items-center landing-navbar__side justify-content-end">
              </div>
            </>
          )}
        </div>
      </nav>

      {/* Mobile Offcanvas Menu */}
      <div
        className="offcanvas offcanvas-end landing-navbar__offcanvas"
        tabIndex="-1"
        id="mobileMenu"
      >
        <div className="offcanvas-header landing-navbar__offcanvas-header">
          <div className="d-flex flex-column align-items-center landing-navbar__logo-container">
            <TadarabLogo className="landing-page__brand-logo" />
            <span className="landing-navbar__business-text text-end">
              for business
            </span>
          </div>
          <button
            type="button"
            className="btn-close btn-close-white landing-navbar__offcanvas-close m-0"
            data-bs-dismiss="offcanvas"
          />
        </div>
        <div className="offcanvas-body landing-navbar__offcanvas-body d-flex flex-column">
          <div className="landing-navbar__mobile-links">
          </div>
        </div>
      </div>
    </>
  );
}
